export const speechData = {
  talk1: {
    title: "Company Expansion Announcement",
    titleKr: "회사 확장 발표",
    type: "speech",
    versions: {
      basic: {
        script: `Good morning, everyone. As the CEO of VisionTech, I am delighted to share some exciting news with you today. Over the past year, our company has experienced significant growth, thanks to the hard work and dedication of all our employees.

I am pleased to announce that <mark>we will be expanding our operations into three new international markets</mark>: Canada, Germany, and South Korea. This expansion will create new job opportunities and strengthen our global presence.

To support this growth, <mark>we are also launching a leadership training program next month</mark>. This program is designed to prepare our employees for management positions and ensure smooth operations in our new locations.

I want to thank each of you for your contributions. Without your efforts, none of this would be possible. <mark>Let's continue to work together to make VisionTech a leader in the global market.</mark> Thank you.`,
        translation: `안녕하세요 여러분. VisionTech의 CEO로서 오늘 여러분과 흥미로운 소식을 나누게 되어 기쁩니다. 지난 한 해 동안 우리 회사는 모든 직원들의 노고와 헌신 덕분에 상당한 성장을 이루었습니다.

우리의 사업을 캐나다, 독일, 한국이라는 세 개의 새로운 국제 시장으로 확장한다는 것을 기쁘게 발표드립니다. 이번 확장으로 새로운 일자리가 창출되고 우리의 글로벌 입지가 강화될 것입니다.

이러한 성장을 뒷받침하기 위해 다음 달에 리더십 교육 프로그램도 시작할 예정입니다. 이 프로그램은 직원들이 관리자 직책을 맡을 수 있도록 준비시키고 새로운 지역에서의 원활한 운영을 보장하기 위해 설계되었습니다.

여러분 한 분 한 분의 기여에 감사드립니다. 여러분의 노력이 없었다면 이 모든 것이 불가능했을 것입니다. VisionTech를 글로벌 시장의 리더로 만들기 위해 계속해서 함께 노력합시다. 감사합니다.`,
        audioUrl: {
          us: "audios/part4/speech/us/us1.mp3",
          uk: "audios/part4/speech/uk/uk1.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main purpose of the announcement?",
        questionKr: "이 발표의 주요 목적은 무엇입니까?",
        options: {
          A: "To introduce a <mark>new CEO</mark>",
          B: "To announce a company <mark>expansion</mark>",
          C: "To explain a <mark>new product</mark> launch",
          D: "To discuss changes in <mark>employee benefits</mark>",
        },
        optionsKr: {
          A: "새로운 CEO를 소개하기 위해",
          B: "회사 확장을 발표하기 위해",
          C: "새로운 제품 출시를 설명하기 위해",
          D: "직원 복리후생의 변경사항을 논의하기 위해",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 새로운 CEO를 소개하기 위해
B: 회사 확장을 발표하기 위해
C: 새로운 제품 출시를 설명하기 위해
D: 직원 복리후생의 변경사항을 논의하기 위해

정답 B: 스크립트의 "I am pleased to announce that we will be expanding our operations into three new international markets"에서 회사 확장을 발표하는 것이 주요 목적임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What is expected to happen <mark>next month</mark>?",
        questionKr: "다음 달에 예정된 것은 무엇입니까?",
        options: {
          A: "The company will start hiring <mark>new employees</mark>",
          B: "The company will launch a <mark>leadership program</mark>",
          C: "The company will open new offices in <mark>three</mark> <mark>countries</mark>",
          D: "The company will release a new <mark>software</mark> <mark>update</mark>",
        },
        optionsKr: {
          A: "회사가 새로운 직원 채용을 시작할 것이다",
          B: "회사가 리더십 프로그램을 시작할 것이다",
          C: "회사가 3개국에 새로운 사무실을 열 것이다",
          D: "회사가 새로운 소프트웨어 업데이트를 출시할 것이다",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
A: 회사가 새로운 직원 채용을 시작할 것이다
B: 회사가 리더십 프로그램을 시작할 것이다
C: 회사가 3개국에 새로운 사무실을 열 것이다
D: 회사가 새로운 소프트웨어 업데이트를 출시할 것이다

정답 B: 스크립트의 "To support this growth, we are also launching a leadership training program next month"에서 다음 달에 리더십 프로그램을 시작할 것임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "Who is the speaker most likely addressing?",
        questionKr: "이 연설을 듣는 대상은 누구일 가능성이 가장 높습니까?",
        options: {
          A: "Customers at a <mark>product launch</mark>",
          B: "Investors at a <mark>financial meeting</mark>",
          C: "Company <mark>employees</mark>",
          D: "Job applicants at a <mark>recruitment</mark> <mark>event</mark>",
        },
        optionsKr: {
          A: "제품 출시 행사의 고객들",
          B: "재무 회의의 투자자들",
          C: "회사의 직원들",
          D: "채용 행사의 구직자들",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
      A: 제품 출시 행사의 고객들
      B: 재무 회의의 투자자들
      C: 회사의 직원들
      D: 채용 행사의 구직자들
      
      정답 C: 연설을 듣는 대상은 누구일 가능성이 가장 높습니까? 라고 물으므로 회사의 직원들이 타당합니다. 스크립트에서 CEO가 "I want to thank each of you for your contributions"라고 하며 "Without your efforts, none of this would be possible"라고 언급하는 것으로 보아 회사의 직원들임을 알 수 있습니다.`,
      },
    ],
  },

  talk2: {
    title: "Company Acquisition Announcement",
    titleKr: "회사 인수 발표",
    type: "speech",
    versions: {
      basic: {
        script: `Good morning, everyone. Thank you for joining me today. I am excited to share an important update about the future of our company. After months of negotiation, we have officially <mark>completed the acquisition</mark> of InnovateTech, a leading software solutions provider.
  This merger will allow us to expand our technology offerings and strengthen our position in the market. We will integrate InnovateTech's advanced AI technology into our existing platforms, making our products more competitive and efficient.
  <mark>Starting next month</mark>, we will hold <mark>training sessions</mark> to help our employees familiarize themselves with the new software. Additionally, our <mark>customer support</mark> team will be <mark>expanded</mark> to ensure a smooth transition for our clients.
  I truly believe this acquisition will bring great opportunities for all of us. Thank you for your continued support.`,
        translation: `안녕하세요 여러분. 오늘 참석해 주셔서 감사합니다. 우리 회사의 미래에 대한 중요한 소식을 나누게 되어 기쁩니다. 수개월간의 협상 끝에, 우리는 선도적인 소프트웨어 솔루션 제공업체인 InnovateTech의 인수를 공식적으로 완료했습니다.
  이번 합병으로 우리는 기술 제품군을 확장하고 시장에서의 입지를 강화할 수 있게 될 것입니다. InnovateTech의 첨단 AI 기술을 우리의 기존 플랫폼에 통합하여 제품을 더욱 경쟁력 있고 효율적으로 만들 것입니다.
  다음 달부터 직원들이 새로운 소프트웨어에 익숙해질 수 있도록 교육 세션을 진행할 예정입니다. 또한, 고객들의 원활한 전환을 위해 고객 지원팀도 확대될 것입니다.
  이번 인수가 우리 모두에게 큰 기회가 될 것이라고 진심으로 믿습니다. 지속적인 지원에 감사드립니다.`,
        audioUrl: {
          us: "audios/part4/speech/us/us2.mp3",
          uk: "audios/part4/speech/uk/uk2.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main topic of the announcement?",
        questionKr: "이 발표의 주요 주제는 무엇입니까?",
        options: {
          A: "A <mark>new product</mark> launch",
          B: "A company <mark>acquisition</mark>",
          C: "An <mark>employee benefits</mark> update",
          D: "A <mark>financial performance</mark> review",
        },
        optionsKr: {
          A: "새로운 제품 출시",
          B: "회사 인수",
          C: "직원 복리후생 업데이트",
          D: "재무 성과 검토",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 새로운 제품 출시
  B: 회사 인수
  C: 직원 복리후생 업데이트
  D: 재무 성과 검토
  
  정답 B: 스크립트의 "we have officially completed the acquisition of InnovateTech"에서 회사 인수가 발표의 주요 주제임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What will happen <mark>next month</mark>?",
        questionKr: "다음 달에 예정된 것은 무엇입니까?",
        options: {
          A: "<mark>Employee training</mark> sessions will begin",
          B: "The company will launch a <mark>new AI</mark> product",
          C: "The company will move to a <mark>new office</mark>",
          D: "The <mark>CEO</mark> will <mark>retire</mark>",
        },
        optionsKr: {
          A: "직원 교육 세션이 시작될 것이다",
          B: "회사가 새로운 AI 제품을 출시할 것이다",
          C: "회사가 새로운 사무실로 이전할 것이다",
          D: "CEO가 은퇴할 것이다",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 직원 교육 세션이 시작될 것이다
  B: 회사가 새로운 AI 제품을 출시할 것이다
  C: 회사가 새로운 사무실로 이전할 것이다
  D: CEO가 은퇴할 것이다
  
  정답 A: 스크립트의 "Starting next month, we will hold training sessions to help our employees familiarize themselves with the new software"에서 다음 달에 직원 교육 세션이 시작될 것임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What does the speaker say about <mark>customer support</mark>?",
        questionKr: "연사는 고객 지원에 대해 무엇이라고 말합니까?",
        options: {
          A: "It will be <mark>outsourced</mark> to another <mark>company</mark>",
          B: "It will remain the <mark>same</mark> after the merger",
          C: "It will be <mark>expanded</mark> to assist with the transition",
          D: "It will be handled by <mark>InnovateTech</mark> employees",
        },
        optionsKr: {
          A: "다른 회사에 외주될 것이다",
          B: "합병 후에도 동일하게 유지될 것이다",
          C: "전환 과정을 지원하기 위해 확대될 것이다",
          D: "InnovateTech 직원들이 담당하게 될 것이다",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 다른 회사에 외주될 것이다
  B: 합병 후에도 동일하게 유지될 것이다
  C: 전환 과정을 지원하기 위해 확대될 것이다
  D: InnovateTech 직원들이 담당하게 될 것이다
  
  정답 C: 스크립트의 "our customer support team will be expanded to ensure a smooth transition for our clients"에서 고객 지원팀이 전환 과정을 지원하기 위해 확대될 것임을 알 수 있습니다.`,
      },
    ],
  },

  talk3: {
    title: "New Product Launch: SmartAir X1",
    titleKr: "신제품 출시: SmartAir X1",
    type: "speech",
    versions: {
      basic: {
        script: `Good morning, everyone. I'm thrilled to introduce <mark>our latest innovation</mark> in home technology, the SmartAir, our most advanced air purifier yet. After years of research and development, we have designed a product that not only removes airborne pollutants but also automatically adjusts to room conditions in real time.
  <mark>Starting next week</mark>, the SmartAir will be available for purchase on our website and at major retail stores nationwide. We are also offering an exclusive 20% discount for the first two weeks to celebrate the launch.
  To help customers get familiar with the new features, we will be hosting <mark>live demonstrations</mark> at selected stores across the country. These sessions will allow potential buyers to see how our product works and ask questions.
  We believe this product will revolutionize air purification, and we are excited for you to experience it. Thank you.`,
        translation: `안녕하세요 여러분. 가정용 기술의 최신 혁신 제품이자 저희의 가장 진보된 공기청정기인 SmartAir를 소개하게 되어 매우 기쁩니다. 수년간의 연구 개발 끝에, 저희는 공기 중 오염물질을 제거할 뿐만 아니라 실시간으로 실내 환경에 자동 조절되는 제품을 설계했습니다.
  다음 주부터 SmartAir는 저희 웹사이트와 전국의 주요 소매점에서 구매하실 수 있습니다. 또한 출시를 기념하여 첫 2주 동안 20% 특별 할인을 제공합니다.
  고객들이 새로운 기능에 익숙해질 수 있도록 전국의 선별된 매장에서 실시간 시연회를 개최할 예정입니다. 이 세션을 통해 잠재 구매자들은 제품의 작동 방식을 보고 질문을 할 수 있습니다.
  이 제품이 공기 정화 방식에 혁명을 일으킬 것이라 믿으며, 여러분이 경험해 보시길 기대합니다. 감사합니다.`,
        audioUrl: {
          us: "audios/part4/speech/us/us3.mp3",
          uk: "audios/part4/speech/uk/uk3.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main purpose of the announcement?",
        questionKr: "이 발표의 주요 목적은 무엇입니까?",
        options: {
          A: "To introduce a <mark>new store</mark> location",
          B: "To explain product <mark>return</mark> <mark>policies</mark>",
          C: "To announce a <mark>new product</mark> launch",
          D: "To discuss a recent <mark>award</mark> the company received",
        },
        optionsKr: {
          A: "새로운 매장 위치를 소개하기 위해",
          B: "제품 반품 정책을 설명하기 위해",
          C: "새로운 제품 출시를 발표하기 위해",
          D: "회사가 최근 받은 상을 논의하기 위해",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 새로운 매장 위치를 소개하기 위해
  B: 제품 반품 정책을 설명하기 위해
  C: 새로운 제품 출시를 발표하기 위해
  D: 회사가 최근 받은 상을 논의하기 위해
  
  정답 C: 스크립트의 "I'm thrilled to introduce our latest innovation in home technology, the SmartAir X1"에서 새로운 제품 출시를 발표하는 것이 주요 목적임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "What is mentioned about the <mark>product</mark> <mark>release</mark>?",
        questionKr: "제품 출시에 대해 언급된 내용은 무엇입니까?",
        options: {
          A: "It will be available in <mark>selected stores</mark> <mark>only</mark>",
          B: "It will be released in the following <mark>month</mark>",
          C: "It will be available for purchase <mark>next week</mark>",
          D: "It will <mark>only</mark> be sold <mark>online</mark>",
        },
        optionsKr: {
          A: "선별된 매장에서만 구매 가능할 것이다",
          B: "다음 달에 출시될 것이다",
          C: "다음 주부터 구매 가능할 것이다",
          D: "온라인에서만 판매될 것이다",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 선별된 매장에서만 구매 가능할 것이다
  B: 다음 달에 출시될 것이다
  C: 다음 주부터 구매 가능할 것이다
  D: 온라인에서만 판매될 것이다
  
  정답 C: 스크립트의 "Starting next week, the SmartAir X1 will be available for purchase on our website and at major retail stores nationwide"에서 다음 주부터 구매 가능하다고 언급하고 있습니다.`,
      },
      {
        id: 3,
        question: "What will the company do to promote the product?",
        questionKr: "회사는 제품 홍보를 위해 무엇을 할 예정입니까?",
        options: {
          A: "Offer free product <mark>samples</mark>",
          B: "Provide free maintenance for a <mark>year</mark>",
          C: "Hold <mark>live demonstrations</mark> at selected stores",
          D: "Give away products to <mark>loyal</mark> customers",
        },
        optionsKr: {
          A: "무료 제품 샘플을 제공한다",
          B: "1년 동안 무료 유지보수를 제공한다",
          C: "선별된 매장에서 실시간 시연회를 개최한다",
          D: "충성 고객들에게 제품을 증정한다",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 무료 제품 샘플을 제공한다
  B: 1년 동안 무료 유지보수를 제공한다
  C: 선별된 매장에서 실시간 시연회를 개최한다
  D: 충성 고객들에게 제품을 증정한다
  
  정답 C: 스크립트의 "we will be hosting live demonstrations at selected stores across the country"에서 선별된 매장에서 실시간 시연회를 개최한다고 언급하고 있습니다.`,
      },
    ],
  },

  talk4: {
    title: "New CEO Introduction",
    titleKr: "신임 CEO 소개",
    type: "speech",
    versions: {
      basic: {
        script: `Good afternoon, everyone. I appreciate you all joining today's special meeting. I am delighted to introduce our <mark>new Chief Executive Officer</mark>, Ms. Katherine Lewis.
  With over 20 years of experience in the technology industry, Ms. Lewis has led multiple successful projects <mark>in artificial intelligence and cloud computing</mark>. Before joining our company, she served as the Chief Operating Officer at InnovateTech, where she played a key role in expanding the company's market share globally.
  <mark>Starting next Monday</mark>, Ms. Lewis will begin her role as CEO. She is eager to meet each of you and discuss our company's vision moving forward. Please join me in welcoming her to our team.`,
        translation: `안녕하세요 여러분. 오늘 특별 회의에 참석해 주셔서 감사합니다. 새로운 최고경영자인 캐서린 루이스 님을 소개하게 되어 기쁩니다.
  루이스 님은 기술 산업에서 20년 이상의 경험을 가지고 있으며, 인공지능과 클라우드 컴퓨팅 분야에서 다수의 성공적인 프로젝트를 이끌어 왔습니다. 우리 회사에 합류하기 전에는 InnovateTech의 최고운영책임자로 재직하며 회사의 글로벌 시장 점유율 확대에 핵심적인 역할을 했습니다.
  다음 주 월요일부터 루이스 님이 CEO로서의 역할을 시작할 예정입니다. 그녀는 여러분 한 분 한 분을 만나 우리 회사의 앞으로의 비전에 대해 논의하기를 간절히 기대하고 있습니다. 우리 팀의 새로운 구성원을 환영해 주시기 바랍니다.`,
        audioUrl: {
          us: "audios/part4/speech/us/us4.mp3",
          uk: "audios/part4/speech/uk/uk4.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main purpose of the announcement?",
        questionKr: "이 발표의 주요 목적은 무엇입니까?",
        options: {
          A: "To discuss the company's recent <mark>financial</mark> <mark>report</mark>",
          B: "To announce a change in company <mark>policies</mark>",
          C: "To introduce a <mark>new</mark> <mark>CEO</mark>",
          D: "To explain an upcoming <mark>product</mark> <mark>launch</mark>",
        },
        optionsKr: {
          A: "회사의 최근 재무 보고서를 논의하기 위해",
          B: "회사 정책의 변경을 발표하기 위해",
          C: "새로운 CEO를 소개하기 위해",
          D: "곧 출시될 제품을 설명하기 위해",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 회사의 최근 재무 보고서를 논의하기 위해
  B: 회사 정책의 변경을 발표하기 위해
  C: 새로운 CEO를 소개하기 위해
  D: 곧 출시될 제품을 설명하기 위해
  
  정답 C: 스크립트의 "I am delighted to introduce our new Chief Executive Officer, Ms. Katherine Lewis"에서 새로운 CEO를 소개하는 것이 주요 목적임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "What is mentioned about <mark>Ms. Lewis's background</mark>?",
        questionKr: "루이스 님의 배경에 대해 언급된 내용은 무엇입니까?",
        options: {
          A: "She has <mark>led multiple successful projects</mark>",
          B: "She has worked at the company for more than a <mark>decade</mark>",
          C: "She was previously the <mark>CFO</mark> of another company",
          D: "She specialized in <mark>financial</mark> <mark>management</mark>",
        },
        optionsKr: {
          A: "다수의 성공적인 프로젝트를 이끌었다",
          B: "이 회사에서 10년 이상 근무했다",
          C: "이전에 다른 회사의 CFO였다",
          D: "재무 관리를 전문으로 했다",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
      A: 다수의 성공적인 프로젝트를 이끌었다
      B: 이 회사에서 10년 이상 근무했다
      C: 이전에 다른 회사의 CFO였다
      D: 재무 관리를 전문으로 했다
      
      정답 A: 스크립트의 "Ms. Lewis has led multiple successful projects"에서 다수의 성공적인 프로젝트를 이끌었다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "When will Ms. Lewis <mark>start</mark> her <mark>new role</mark>?",
        questionKr: "루이스 님은 언제 새로운 역할을 시작합니까?",
        options: {
          A: "Next <mark>Monday</mark>",
          B: "Next <mark>month</mark>",
          C: "<mark>Immediately</mark>",
          D: "Next <mark>year</mark>",
        },
        optionsKr: {
          A: "다음 주 월요일",
          B: "다음 달",
          C: "즉시",
          D: "내년",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 다음 주 월요일
  B: 다음 달
  C: 즉시
  D: 내년
  
  정답 A: 스크립트의 "Starting next Monday, Ms. Lewis will begin her role as CEO"에서 다음 주 월요일에 CEO로서의 역할을 시작한다는 것을 알 수 있습니다.`,
      },
    ],
  },

  talk5: {
    title: "Annual Charity Gala Speech",
    titleKr: "연례 자선 갈라 연설",
    type: "speech",
    versions: {
      basic: {
        script: `Good evening, everyone. I am honored to stand before you at this year's <mark>Annual Charity Gala</mark>. This event is a wonderful opportunity to come together as a community and support those in need.
  Tonight, all proceeds from ticket sales and donations will go to Hope for Kids, an organization dedicated to providing education and medical care for underprivileged children. <mark>Last year</mark>, thanks to your generosity, we raised <mark>over $500,000</mark>, which helped build two new schools.
  As we enjoy this evening, let's remember the impact we can make. I encourage each of you to take part in our <mark>silent auction</mark> and donation drive. Together, we can create a brighter future for children around the world. Thank you.`,
        translation: `안녕하세요 여러분. 올해의 연례 자선 갈라 행사에서 여러분 앞에 서게 되어 영광입니다. 이 행사는 지역사회가 하나가 되어 도움이 필요한 이들을 지원할 수 있는 훌륭한 기회입니다.
  오늘 밤 티켓 판매와 기부금 전액은 소외계층 아동들에게 교육과 의료 서비스를 제공하는 단체인 Hope for Kids에 전달될 예정입니다. 작년에는 여러분의 관대한 기부 덕분에 50만 달러 이상을 모금했고, 이를 통해 두 개의 새로운 학교를 건립할 수 있었습니다.
  오늘 저녁을 즐기시면서 우리가 만들 수 있는 영향력을 기억해 주시기 바랍니다. 여러분 모두 경매와 기부 행사에 참여해 주시기를 부탁드립니다. 함께라면 전 세계 아이들을 위해 더 밝은 미래를 만들 수 있습니다. 감사합니다.`,
        audioUrl: {
          us: "audios/part4/speech/us/us5.mp3",
          uk: "audios/part4/speech/uk/uk5.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the purpose of the event?",
        questionKr: "이 행사의 목적은 무엇입니까?",
        options: {
          A: "To celebrate a company's <mark>anniversary</mark>",
          B: "To introduce a <mark>new product</mark> line",
          C: "To raise funds for a <mark>charity</mark>",
          D: "To recognize outstanding <mark>employees</mark>",
        },
        optionsKr: {
          A: "회사의 기념일을 축하하기 위해",
          B: "새로운 제품 라인을 소개하기 위해",
          C: "자선 단체를 위한 기금을 모으기 위해",
          D: "우수 직원들을 표창하기 위해",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 회사의 기념일을 축하하기 위해
  B: 새로운 제품 라인을 소개하기 위해
  C: 자선 단체를 위한 기금을 모으기 위해
  D: 우수 직원들을 표창하기 위해
  
  정답 C: 스크립트의 "Tonight, all proceeds from ticket sales and donations will go to Hope for Kids"에서 이 행사가 자선 단체를 위한 기금을 모으는 것이 목적임을 알 수 있습니다. 또한 "Annual Charity Gala"라는 행사명에서도 자선이 목적임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "What does the speaker say about <mark>last year's event</mark>?",
        questionKr: "연사는 작년 행사에 대해 무엇이라고 말합니까?",
        options: {
          A: "It had <mark>more attendees</mark> than this year",
          B: "It was canceled due to <mark>bad</mark> <mark>weather</mark>",
          C: "It raised over <mark>$500,000</mark>",
          D: "It supported <mark>local</mark> <mark>businesses</mark>",
        },
        optionsKr: {
          A: "올해보다 더 많은 참석자가 있었다",
          B: "악천후로 인해 취소되었다",
          C: "50만 달러 이상을 모금했다",
          D: "지역 사업체들을 지원했다",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 올해보다 더 많은 참석자가 있었다
  B: 악천후로 인해 취소되었다
  C: 50만 달러 이상을 모금했다
  D: 지역 사업체들을 지원했다
  
  정답 C: 스크립트의 "Last year, thanks to your generosity, we raised over $500,000, which helped build two new schools"에서 작년 행사에서 50만 달러 이상을 모금했다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What does the speaker encourage the <mark>audience</mark> to do?",
        questionKr: "연사는 청중들에게 무엇을 하도록 권장합니까?",
        options: {
          A: "<mark>Volunteer</mark> at the organization",
          B: "Join a <mark>networking</mark> session",
          C: "Participate in a silent <mark>auction</mark>",
          D: "Attend a fundraising <mark>workshop</mark>",
        },
        optionsKr: {
          A: "단체에서 자원봉사를 하기",
          B: "네트워킹 세션에 참여하기",
          C: "경매에 참여하기",
          D: "모금 워크샵에 참석하기",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 단체에서 자원봉사를 하기
  B: 네트워킹 세션에 참여하기
  C: 경매에 참여하기
  D: 모금 워크샵에 참석하기
  
  정답 C: 스크립트의 "I encourage each of you to take part in our silent auction and donation drive"에서 청중들에게 경매에 참여하도록 권장하고 있음을 알 수 있습니다.`,
      },
    ],
  },

  talk6: {
    title: "30th Anniversary Commemorative Speech",
    titleKr: "창립 30주년 기념 연설",
    type: "speech",
    versions: {
      basic: {
        script: `Good afternoon, everyone. It is <mark>an honor to stand before you today as we celebrate the 30th anniversary of our company</mark>. Since our founding in 1994, we have grown from a small startup to an industry leader, thanks to the dedication and hard work of our employees.
  <mark>As we reflect on the past three decades, I want to recognize the contributions of our long-time employees</mark>. Many of you have been with us for years, and your commitment has shaped our success.
  <mark>Looking ahead, we are launching new sustainability initiatives to reduce our environmental impact and give back to the community</mark>. Together, we will continue to innovate and make a difference.
  Once again, thank you all for being part of this incredible journey. Let's celebrate this milestone together!`,
        translation: `안녕하세요 여러분. 오늘 우리 회사의 창립 30주년을 기념하는 자리에서 여러분 앞에 서게 되어 영광입니다. 1994년 창립 이래로, 우리는 직원들의 헌신과 노고 덕분에 작은 스타트업에서 업계의 선도 기업으로 성장했습니다.
  지난 30년을 돌아보며, 오랫동안 함께해 온 직원들의 공헌을 인정하고 싶습니다. 여러분 중 많은 분들이 오랫동안 우리와 함께 해왔고, 여러분의 헌신이 우리의 성공을 만들어냈습니다.
  앞으로를 내다보며, 우리는 환경 영향을 줄이고 지역사회에 보답하기 위한 새로운 지속가능성 이니셔티브를 시작할 예정입니다. 함께라면 우리는 계속해서 혁신하고 변화를 만들어낼 수 있을 것입니다.
  다시 한 번, 이 놀라운 여정의 일원이 되어주셔서 감사합니다. 이 의미 있는 이정표를 함께 축하합시다!`,
        audioUrl: {
          us: "audios/part4/speech/us/us6.mp3",
          uk: "audios/part4/speech/uk/uk6.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the purpose of the speech?",
        questionKr: "이 연설의 목적은 무엇입니까?",
        options: {
          A: "To announce a company <mark>merger</mark>",
          B: "To introduce a <mark>new</mark> <mark>CEO</mark>",
          C: "To celebrate an <mark>anniversary</mark>",
          D: "To explain <mark>new</mark> company <mark>policies</mark>",
        },
        optionsKr: {
          A: "회사 합병을 발표하기 위해",
          B: "새로운 CEO를 소개하기 위해",
          C: "기념일을 축하하기 위해",
          D: "새로운 회사 정책을 설명하기 위해",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 회사 합병을 발표하기 위해
  B: 새로운 CEO를 소개하기 위해
  C: 기념일을 축하하기 위해
  D: 새로운 회사 정책을 설명하기 위해
  
  정답 C: 스크립트의 "as we celebrate the 30th anniversary of our company"에서 회사의 30주년 기념일을 축하하는 것이 연설의 목적임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What does the speaker say about the <mark>employees</mark>?",
        questionKr: "연사는 직원들에 대해 무엇이라고 말합니까?",
        options: {
          A: "They will receive special <mark>bonuses</mark>",
          B: "They will be relocated to a <mark>new</mark> <mark>office</mark>",
          C: "They have <mark>contributed</mark> to the company's <mark>success</mark>",
          D: "They will participate in <mark>leadership</mark> <mark>training</mark>",
        },
        optionsKr: {
          A: "특별 보너스를 받을 것이다",
          B: "새로운 사무실로 이전할 것이다",
          C: "회사의 성공에 기여해왔다",
          D: "리더십 교육에 참여할 것이다",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 특별 보너스를 받을 것이다
  B: 새로운 사무실로 이전할 것이다
  C: 회사의 성공에 기여해왔다
  D: 리더십 교육에 참여할 것이다
  
  정답 C: 스크립트의 "I want to recognize the contributions of our long-time employees"와 "your commitment has shaped our success"에서 직원들이 회사의 성공에 기여했다고 언급하고 있음을 알 수 있습니다.`,
      },
      {
        id: 3,
        question:
          "What will the company <mark>focus</mark> on in the <mark>future</mark>?",
        questionKr: "회사는 앞으로 무엇에 중점을 둘 예정입니까?",
        options: {
          A: "<mark>Expanding</mark> its workforce",
          B: "<mark>Sustainability</mark> <mark>initiatives</mark>",
          C: "Acquiring a <mark>new partner</mark> company",
          D: "Increasing employee <mark>salaries</mark>",
        },
        optionsKr: {
          A: "인력 확대",
          B: "지속가능한 발전 계획",
          C: "새로운 파트너 회사 인수",
          D: "직원 급여 인상",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 인력 확대
  B: 지속가능한 발전 계획
  C: 새로운 파트너 회사 인수
  D: 직원 급여 인상
  
  정답 B: 스크립트의 "we are launching new sustainability initiatives to reduce our environmental impact and give back to the community"에서 회사가 앞으로 지속가능성 이니셔티브에 중점을 둘 것임을 알 수 있습니다.`,
      },
    ],
  },

  talk7: {
    title: "Graduation Ceremony Speech",
    titleKr: "졸업식 연설",
    type: "speech",
    versions: {
      basic: {
        script: `<mark>Good afternoon, graduates</mark>, faculty, and honored guests. Today, we <mark>gather here to celebrate</mark> the remarkable achievements of the Class of 2024. Each of you has worked tirelessly to reach this moment, and I am proud to stand before you on this special day.
  As you step into the next chapter of your lives, remember <mark>that learning does not stop here</mark>. Whether you are beginning a new career, pursuing further education, or taking time to explore new opportunities, the knowledge and experiences you have gained will guide you forward.
  To commemorate this occasion, we invite all graduates to join us for a reception <mark>in the main hall following the ceremony</mark>. This is a great opportunity to celebrate with your friends, family, and professors.
  Congratulations once again! We look forward to seeing all the incredible things you will accomplish.`,
        translation: `졸업생, 교수진, 그리고 귀빈 여러분, 안녕하십니까. 오늘 우리는 2024학년도 졸업생들의 놀라운 성취를 축하하기 위해 이 자리에 모였습니다. 여러분 모두가 이 순간을 위해 쉬지 않고 노력해왔고, 저는 이 특별한 날에 여러분 앞에 서게 되어 자랑스럽습니다.
  여러분이 삶의 새로운 장을 시작하면서, 배움이 여기서 끝나지 않는다는 것을 기억하시기 바랍니다. 새로운 경력을 시작하든, 더 높은 교육을 추구하든, 새로운 기회를 탐색하는 시간을 가지든, 여러분이 얻은 지식과 경험이 앞으로의 길을 인도할 것입니다.
  이 자리를 기념하기 위해, 모든 졸업생들을 졸업식 후 메인 홀에서 열리는 리셉션에 초대합니다. 이는 친구들, 가족들, 그리고 교수님들과 함께 축하할 수 있는 좋은 기회가 될 것입니다.
  다시 한 번 축하드립니다! 여러분이 앞으로 이루어낼 놀라운 일들을 기대하겠습니다.`,
        audioUrl: {
          us: "audios/part4/speech/us/us7.mp3",
          uk: "audios/part4/speech/uk/uk7.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main purpose of the speech?",
        questionKr: "이 연설의 주요 목적은 무엇입니까?",
        options: {
          A: "To explain <mark>graduation</mark> <mark>requirements</mark>",
          B: "To <mark>congratulate</mark> the <mark>graduates</mark>",
          C: "To introduce a <mark>guest</mark> <mark>speaker</mark>",
          D: "To announce a <mark>scholarship</mark> program",
        },
        optionsKr: {
          A: "졸업 요건을 설명하기 위해",
          B: "졸업생들을 축하하기 위해",
          C: "초청 연사를 소개하기 위해",
          D: "장학금 프로그램을 발표하기 위해",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 졸업 요건을 설명하기 위해
  B: 졸업생들을 축하하기 위해
  C: 초청 연사를 소개하기 위해
  D: 장학금 프로그램을 발표하기 위해
  
  정답 B: 스크립트의 "Today, we gather here to celebrate the remarkable achievements of the Class of 2024" 및 "Congratulations once again!"에서 연설의 주요 목적이 졸업생들을 축하하기 위한 것임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What does the speaker suggest about <mark>learning</mark>?",
        questionKr: "연사는 학습에 대해 무엇이라고 제안합니까?",
        options: {
          A: "It <mark>ends</mark> after graduation",
          B: "It <mark>continues</mark> beyond school",
          C: "It is <mark>only</mark> useful for finding a <mark>job</mark>",
          D: "It is most important in <mark>early</mark> <mark>years</mark>",
        },
        optionsKr: {
          A: "졸업 후에 끝난다",
          B: "학교를 넘어서도 계속된다",
          C: "취업에만 유용하다",
          D: "초기 시절에 가장 중요하다",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 졸업 후에 끝난다
  B: 학교를 넘어서도 계속된다
  C: 취업에만 유용하다
  D: 초기 시절에 가장 중요하다
  
  정답 B: 스크립트의 "remember that learning does not stop here"에서 학습이 졸업 후에도 계속된다는 것을 제안하고 있음을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What will take place <mark>after the ceremony</mark>?",
        questionKr: "졸업식 후에 무엇이 열립니까?",
        options: {
          A: "A reception in the <mark>main</mark> <mark>hall</mark>",
          B: "A <mark>career workshop</mark> for students",
          C: "A <mark>campus tour</mark> for guests",
          D: "A <mark>farewell speech</mark> by the faculty",
        },
        optionsKr: {
          A: "메인 홀에서의 리셉션",
          B: "학생들을 위한 취업 워크샵",
          C: "손님들을 위한 캠퍼스 투어",
          D: "교수진의 작별 연설",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 메인 홀에서의 리셉션
  B: 학생들을 위한 취업 워크샵
  C: 손님들을 위한 캠퍼스 투어
  D: 교수진의 작별 연설
  
  정답 A: 스크립트의 "we invite all graduates to join us for a reception in the main hall following the ceremony"에서 졸업식 후에 메인 홀에서 리셉션이 열린다는 것을 알 수 있습니다.`,
      },
    ],
  },

  talk8: {
    title: "Employee Recognition Ceremony Speech",
    titleKr: "직원 표창식 연설",
    type: "speech",
    versions: {
      basic: {
        script: `Good evening, everyone. It is a great honor to stand before you at this year's Annual Employee Recognition Ceremony. Tonight, we celebrate the hard work and dedication of our outstanding team members.
  This year's <mark>Employee of the Year Award</mark> goes to Ms. Rachel Parker, our senior marketing manager. Over the past year, Rachel has led multiple successful campaigns, helping our company <mark>expand into new markets</mark>. Her creativity, leadership, and commitment to excellence have made a significant impact.
  Rachel, on behalf of the entire company, I want to thank you for your dedication. Please come forward to <mark>accept your award</mark>. Congratulations!`,
        translation: `안녕하세요 여러분. 올해의 연례 직원 표창식에서 여러분 앞에 서게 되어 큰 영광입니다. 오늘 밤, 우리는 뛰어난 팀원들의 노고와 헌신을 기념합니다.
  올해의 직원상은 수석 마케팅 매니저인 레이첼 파커 씨에게 돌아갑니다. 지난 한 해 동안 레이첼은 여러 성공적인 캠페인을 이끌며 우리 회사가 새로운 시장으로 확장하는 데 도움을 주었습니다. 그녀의 창의성, 리더십, 그리고 탁월함에 대한 헌신이 큰 영향을 미쳤습니다.
  레이첼, 회사를 대표하여 당신의 헌신에 감사드립니다. 앞으로 나와 상을 받아주시기 바랍니다. 축하합니다!`,
        audioUrl: {
          us: "audios/part4/speech/us/us8.mp3",
          uk: "audios/part4/speech/uk/uk8.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main purpose of the speech?",
        questionKr: "이 연설의 주요 목적은 무엇입니까?",
        options: {
          A: "To introduce a <mark>new</mark> team <mark>member</mark>",
          B: "To present an <mark>award</mark>",
          C: "To announce a company <mark>policy</mark> <mark>change</mark>",
          D: "To discuss a <mark>financial</mark> <mark>report</mark>",
        },
        optionsKr: {
          A: "새로운 팀원을 소개하기 위해",
          B: "상을 수여하기 위해",
          C: "회사 정책 변경을 발표하기 위해",
          D: "재무 보고서를 논의하기 위해",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 새로운 팀원을 소개하기 위해
  B: 상을 수여하기 위해
  C: 회사 정책 변경을 발표하기 위해
  D: 재무 보고서를 논의하기 위해
  
  정답 B: 스크립트의 "This year's Employee of the Year Award goes to Ms. Rachel Parker" 및 "Please come forward to accept your award"에서 연설의 주요 목적이 상을 수여하기 위한 것임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "What is mentioned about the <mark>award</mark> <mark>recipient</mark>?",
        questionKr: "수상자에 대해 언급된 내용은 무엇입니까?",
        options: {
          A: "She <mark>recently joined</mark> the <mark>company</mark>",
          B: "She helped the company expand into <mark>new</mark> <mark>markets</mark>",
          C: "She worked in the <mark>finance</mark> <mark>department</mark>",
          D: "She was promoted to a <mark>new</mark> <mark>position</mark>",
        },
        optionsKr: {
          A: "최근에 회사에 입사했다",
          B: "회사가 새로운 시장으로 확장하는 데 도움을 주었다",
          C: "재무부서에서 일했다",
          D: "새로운 직책으로 승진했다",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 최근에 회사에 입사했다
  B: 회사가 새로운 시장으로 확장하는 데 도움을 주었다
  C: 재무부서에서 일했다
  D: 새로운 직책으로 승진했다
  
  정답 B: 스크립트의 "Rachel has led multiple successful campaigns, helping our company expand into new markets"에서 레이첼이 회사가 새로운 시장으로 확장하는 데 도움을 주었다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What is the speaker likely to do next?",
        questionKr: "연사는 다음에 무엇을 할 것 같습니까?",
        options: {
          A: "Hand over the <mark>award</mark> to the winner",
          B: "Announce a <mark>new</mark> <mark>project</mark>",
          C: "Invite <mark>another</mark> <mark>speaker</mark> to the stage",
          D: "Discuss the company's <mark>sales</mark> <mark>performance</mark>",
        },
        optionsKr: {
          A: "수상자에게 상을 전달할 것이다",
          B: "새로운 프로젝트를 발표할 것이다",
          C: "다른 연사를 무대로 초대할 것이다",
          D: "회사의 매출 실적을 논의할 것이다",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 수상자에게 상을 전달할 것이다
  B: 새로운 프로젝트를 발표할 것이다
  C: 다른 연사를 무대로 초대할 것이다
  D: 회사의 매출 실적을 논의할 것이다
  
  정답 A: 스크립트의 "Please come forward to accept your award"에서 연사가 다음으로 수상자에게 상을 전달할 것임을 추론할 수 있습니다.`,
      },
    ],
  },

  talk9: {
    title: "Retirement Appreciation Speech",
    titleKr: "퇴직 감사 연설",
    type: "speech",
    versions: {
      basic: {
        script: `Good evening, everyone. Today, we are here to celebrate and honor the incredible career of Mr. Thomas Reynolds, <mark>who is retiring</mark> after 35 years of dedicated service to our company.
  Thomas joined our company in 1989 as a junior engineer, and over the years, <mark>he played a key role</mark> in developing many of our most successful projects. His leadership and expertise have inspired countless colleagues, and his contributions will not be forgotten.
  As a token of our appreciation, we have prepared a special farewell gift for Thomas. We are also hosting a <mark>retirement dinner</mark> in the banquet hall after this ceremony, and we invite all of you to join us in celebrating this special occasion.
  Thomas, thank you for your dedication and hard work. We wish you all the best in your next chapter!`,
        translation: `안녕하세요 여러분. 오늘 우리는 35년간 회사에 헌신적으로 봉사하신 토마스 레이놀즈 님의 놀라운 경력을 기념하고 기리기 위해 이 자리에 모였습니다.
  토마스 님은 1989년에 주니어 엔지니어로 우리 회사에 입사하셨고, 수년간 우리의 가장 성공적인 프로젝트들을 개발하는 데 핵심적인 역할을 해오셨습니다. 그의 리더십과 전문성은 수많은 동료들에게 영감을 주었고, 그의 공헌은 잊혀지지 않을 것입니다.
  감사의 표시로, 우리는 토마스 님을 위한 특별한 송별 선물을 준비했습니다. 또한 이 행사 후에 연회장에서 은퇴 기념 만찬을 개최할 예정이니, 여러분 모두 이 특별한 자리를 함께 축하해 주시기 바랍니다.
  토마스 님, 헌신과 노고에 감사드립니다. 새로운 인생의 장에서도 행복하시길 기원합니다!`,
        audioUrl: {
          us: "audios/part4/speech/us/us9.mp3",
          uk: "audios/part4/speech/uk/uk9.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main purpose of the speech?",
        questionKr: "이 연설의 주요 목적은 무엇입니까?",
        options: {
          A: "To introduce a <mark>new</mark> <mark>employee</mark>",
          B: "To announce a <mark>promotion</mark>",
          C: "To honor a <mark>retiring</mark> <mark>employee</mark>",
          D: "To discuss <mark>company</mark> <mark>achievements</mark>",
        },
        optionsKr: {
          A: "새로운 직원을 소개하기 위해",
          B: "승진을 발표하기 위해",
          C: "퇴직하는 직원을 기리기 위해",
          D: "회사의 성과를 논의하기 위해",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 새로운 직원을 소개하기 위해
  B: 승진을 발표하기 위해
  C: 퇴직하는 직원을 기리기 위해
  D: 회사의 성과를 논의하기 위해
  
  정답 C: 스크립트의 "Today, we are here to celebrate and honor the incredible career of Mr. Thomas Reynolds, who is retiring after 35 years"에서 퇴직하는 직원을 기리기 위한 연설임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What is mentioned about <mark>Thomas Reynolds</mark>?",
        questionKr: "토마스 레이놀즈에 대해 언급된 내용은 무엇입니까?",
        options: {
          A: "He <mark>recently joined</mark> the company",
          B: "He has been working for <mark>20</mark> <mark>years</mark>",
          C: "He played a <mark>key role</mark> in many projects",
          D: "He will continue working as a <mark>consultant</mark>",
        },
        optionsKr: {
          A: "최근에 회사에 입사했다",
          B: "20년 동안 일해왔다",
          C: "많은 프로젝트에서 핵심적인 역할을 했다",
          D: "컨설턴트로 계속 일할 예정이다",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 최근에 회사에 입사했다
  B: 20년 동안 일해왔다
  C: 많은 프로젝트에서 핵심적인 역할을 했다
  D: 컨설턴트로 계속 일할 예정이다
  
  정답 C: 스크립트의 "he played a key role in developing many of our most successful projects"에서 토마스가 많은 프로젝트에서 핵심적인 역할을 했다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What will take place <mark>after the ceremony</mark>?",
        questionKr: "행사 후에 무엇이 열립니까?",
        options: {
          A: "A presentation on the company's <mark>history</mark>",
          B: "A <mark>leadership training</mark> session",
          C: "A <mark>retirement</mark> <mark>dinner</mark>",
          D: "A <mark>farewell</mark> <mark>speech</mark> by Thomas Reynolds",
        },
        optionsKr: {
          A: "회사 역사에 대한 발표",
          B: "리더십 교육 세션",
          C: "퇴직 기념 만찬",
          D: "토마스 레이놀즈의 작별 연설",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 회사 역사에 대한 발표
  B: 리더십 교육 세션
  C: 퇴직 기념 만찬
  D: 토마스 레이놀즈의 작별 연설
  
  정답 C: 스크립트의 "We are also hosting a retirement dinner in the banquet hall after this ceremony"에서 행사 후에 퇴직 기념 만찬이 열린다는 것을 알 수 있습니다.`,
      },
    ],
  },

  talk10: {
    title: "New Employee Training Seminar Introduction",
    titleKr: "신입 직원 교육 세미나 소개",
    type: "speech",
    versions: {
      basic: {
        script: `Good morning, everyone, and welcome to our New Employee <mark>Training Seminar</mark>. Over the next two days, you will learn essential skills to succeed in your roles.
  Today, we will start with an overview of company policies and workplace ethics. After lunch, we will have a session on effective <mark>communication skills</mark>, where you will participate in group discussions and exercises.
  Tomorrow, we will focus on <mark>project management techniques</mark> and how to use our internal software systems. By the end of this training, you will have the knowledge and tools needed to perform your job efficiently.
  If you have any questions, feel free to ask at any time. Let's get started!`,
        translation: `안녕하세요 여러분, 신입 직원 교육 세미나에 오신 것을 환영합니다. 앞으로 이틀 동안, 여러분은 각자의 역할에서 성공하는 데 필요한 핵심 기술들을 배우게 될 것입니다.
  오늘은 회사 정책과 직장 윤리에 대한 개요로 시작하겠습니다. 점심 식사 후에는 효과적인 의사소통 기술에 대한 세션이 있을 예정이며, 여러분은 그룹 토론과 실습에 참여하게 됩니다.
  내일은 프로젝트 관리 기법과 내부 소프트웨어 시스템 사용법에 대해 중점적으로 다룰 예정입니다. 이 교육이 끝날 때쯤이면, 여러분은 업무를 효율적으로 수행하는 데 필요한 지식과 도구를 갖추게 될 것입니다.
  질문이 있으시다면 언제든 자유롭게 해 주시기 바랍니다. 그럼 시작하겠습니다!`,
        audioUrl: {
          us: "audios/part4/speech/us/us10.mp3",
          uk: "audios/part4/speech/uk/uk10.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the purpose of the talk?",
        questionKr: "이 연설의 목적은 무엇입니까?",
        options: {
          A: "To introduce a <mark>training</mark> <mark>seminar</mark>",
          B: "To discuss the company's <mark>hiring</mark> <mark>process</mark>",
          C: "To announce changes to workplace <mark>policies</mark>",
          D: "To provide details about a company <mark>event</mark>",
        },
        optionsKr: {
          A: "교육 세미나를 소개하기 위해",
          B: "회사의 채용 과정을 논의하기 위해",
          C: "직장 정책의 변경사항을 발표하기 위해",
          D: "회사 행사에 대한 세부사항을 제공하기 위해",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 교육 세미나를 소개하기 위해
  B: 회사의 채용 과정을 논의하기 위해
  C: 직장 정책의 변경사항을 발표하기 위해
  D: 회사 행사에 대한 세부사항을 제공하기 위해
  
  정답 A: 스크립트의 첫 문장 "welcome to our New Employee Training Seminar"에서 이 연설의 목적이 교육 세미나를 소개하는 것임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What will be covered <mark>after lunch</mark> today?",
        questionKr: "오늘 점심 식사 후에는 무엇을 다룰 예정입니까?",
        options: {
          A: "Company <mark>history</mark>",
          B: "Workplace <mark>safety</mark> <mark>regulations</mark>",
          C: "<mark>Communication skills</mark> training",
          D: "A product <mark>demonstration</mark>",
        },
        optionsKr: {
          A: "회사 역사",
          B: "직장 안전 규정",
          C: "의사소통 기술 교육",
          D: "제품 시연",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 회사 역사
  B: 직장 안전 규정
  C: 의사소통 기술 교육
  D: 제품 시연
  
  정답 C: 스크립트의 "After lunch, we will have a session on effective communication skills"에서 점심 식사 후에는 의사소통 기술 교육 세션이 있을 것임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What will participants learn <mark>tomorrow</mark>?",
        questionKr: "참가자들은 내일 무엇을 배울 예정입니까?",
        options: {
          A: "How to handle customer <mark>complaints</mark>",
          B: "How to <mark>manage</mark> <mark>projects</mark>",
          C: "How to improve their <mark>presentation</mark> <mark>skills</mark>",
          D: "How to organize company <mark>events</mark>",
        },
        optionsKr: {
          A: "고객 불만 처리 방법",
          B: "프로젝트 관리 방법",
          C: "프레젠테이션 기술 향상 방법",
          D: "회사 행사 조직 방법",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 고객 불만 처리 방법
  B: 프로젝트 관리 방법
  C: 프레젠테이션 기술 향상 방법
  D: 회사 행사 조직 방법
  
  정답 B: 스크립트의 "Tomorrow, we will focus on project management techniques"에서 내일은 프로젝트 관리 기법에 대해 배울 것임을 알 수 있습니다.`,
      },
    ],
  },

  talk11: {
    title: "Leadership Development Workshop Introduction",
    titleKr: "리더십 개발 워크숍 소개",
    type: "speech",
    versions: {
      basic: {
        script: `Good morning, everyone, and welcome to our <mark>Leadership Development Workshop</mark>. This two-day program is designed to help you enhance your leadership skills and improve team performance.
  Today, we will begin with a session on motivating employees and fostering teamwork. <mark>In the afternoon</mark>, we will discuss effective <mark>decision-making strategies</mark>, where you will work on case studies and real-world scenarios.
  <mark>Tomorrow</mark>, we will <mark>focus on conflict resolution</mark> techniques. Learning how to manage workplace disputes effectively is crucial for any leader. By the end of this workshop, you will have valuable tools to lead your teams with confidence.
  Now, let's start with our first session.`,
        translation: `안녕하세요 여러분, 리더십 개발 워크숍에 오신 것을 환영합니다. 이 2일간의 프로그램은 여러분의 리더십 기술을 향상시키고 팀 성과를 개선하는 데 도움을 주도록 설계되었습니다.
  오늘은 직원 동기부여와 팀워크 증진에 대한 세션으로 시작하겠습니다. 오후에는 효과적인 의사결정 전략에 대해 논의할 예정이며, 사례 연구와 실제 시나리오를 다루게 될 것입니다.
  내일은 갈등 해결 기법에 중점을 둘 예정입니다. 직장 내 분쟁을 효과적으로 관리하는 방법을 배우는 것은 모든 리더에게 매우 중요합니다. 이 워크숍이 끝날 때쯤이면, 여러분은 자신감을 가지고 팀을 이끌 수 있는 귀중한 도구들을 갖추게 될 것입니다.
  이제 첫 번째 세션을 시작하겠습니다.`,
        audioUrl: {
          us: "audios/part4/speech/us/us11.mp3",
          uk: "audios/part4/speech/uk/uk11.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the purpose of the talk?",
        questionKr: "이 연설의 목적은 무엇입니까?",
        options: {
          A: "To introduce a <mark>new</mark> company <mark>policy</mark>",
          B: "To open a <mark>leadership</mark> <mark>workshop</mark>",
          C: "To announce a <mark>management</mark> <mark>restructuring</mark>",
          D: "To discuss recent employee <mark>feedback</mark>",
        },
        optionsKr: {
          A: "새로운 회사 정책을 소개하기 위해",
          B: "리더십 워크숍을 시작하기 위해",
          C: "경영진 구조조정을 발표하기 위해",
          D: "최근 직원 피드백을 논의하기 위해",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 새로운 회사 정책을 소개하기 위해
  B: 리더십 워크숍을 시작하기 위해
  C: 경영진 구조조정을 발표하기 위해
  D: 최근 직원 피드백을 논의하기 위해
  
  정답 B: 스크립트의 첫 문장 "welcome to our Leadership Development Workshop"에서 이 연설의 목적이 리더십 워크숍을 시작하기 위한 것임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What topic will be covered <mark>in the afternoon</mark>?",
        questionKr: "오후에는 어떤 주제를 다룰 예정입니까?",
        options: {
          A: "<mark>Conflict</mark> <mark>resolution</mark>",
          B: "<mark>Decision-making</mark> <mark>strategies</mark>",
          C: "Employee <mark>recruitment</mark>",
          D: "Workplace <mark>technology</mark> training",
        },
        optionsKr: {
          A: "갈등 해결",
          B: "의사결정 전략",
          C: "직원 채용",
          D: "직장 기술 교육",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
  A: 갈등 해결
  B: 의사결정 전략
  C: 직원 채용
  D: 직장 기술 교육
  
  정답 B: 스크립트의 "In the afternoon, we will discuss effective decision-making strategies"에서 오후에는 의사결정 전략에 대해 다룰 것임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What will participants learn <mark>tomorrow</mark>?",
        questionKr: "참가자들은 내일 무엇을 배울 예정입니까?",
        options: {
          A: "How to handle <mark>conflicts</mark>",
          B: "How to develop <mark>business</mark> <mark>strategies</mark>",
          C: "How to manage company <mark>finances</mark>",
          D: "How to conduct <mark>performance</mark> <mark>evaluations</mark>",
        },
        optionsKr: {
          A: "갈등을 다루는 방법",
          B: "사업 전략을 개발하는 방법",
          C: "회사 재정을 관리하는 방법",
          D: "성과 평가를 수행하는 방법",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 갈등을 다루는 방법
  B: 사업 전략을 개발하는 방법
  C: 회사 재정을 관리하는 방법
  D: 성과 평가를 수행하는 방법
  
  정답 A: 스크립트의 "Tomorrow, we will focus on conflict resolution techniques"에서 내일은 갈등 해결 기법에 대해 배울 것임을 알 수 있습니다.`,
      },
    ],
  },

  talk12: {
    title: "Product Launch Event Speech",
    titleKr: "제품 출시 행사 연설",
    type: "speech",
    versions: {
      basic: {
        script: `Good evening, everyone. <mark>Thank you all for joining us at the official launch of our latest innovation</mark>, the VisionX Smartwatch. This is a milestone moment for our company, and we are excited to share this groundbreaking product with you.
  The VisionX Smartwatch offers advanced health tracking features, real-time notifications, and an extended battery life of up to 10 days. It is designed to help users stay connected while maintaining an active lifestyle.
  Starting next Monday, the VisionX Smartwatch will be available for purchase in stores and online. <mark>As a special promotion, customers who order within the first week will receive a 15% discount</mark>.
  Once again, thank you for being part of this event. <mark>Now, let's move on to the product demonstration!</mark>`,
        translation: `안녕하세요 여러분. 저희의 최신 혁신 제품인 VisionX 스마트워치의 공식 출시 행사에 참석해 주셔서 감사합니다. 이는 우리 회사의 중요한 순간이며, 이 혁신적인 제품을 여러분과 공유하게 되어 기쁩니다.
  VisionX 스마트워치는 고급 건강 추적 기능, 실시간 알림, 그리고 최대 10일까지 지속되는 배터리 수명을 제공합니다. 이는 사용자들이 활동적인 라이프스타일을 유지하면서도 연결성을 유지할 수 있도록 설계되었습니다.
  다음 주 월요일부터 VisionX 스마트워치를 매장과 온라인에서 구매하실 수 있습니다. 특별 프로모션으로, 첫 달 동안 구매하시는 고객께는 15% 할인을 제공합니다.
  다시 한 번 이 행사에 참여해 주셔서 감사합니다. 이제 제품 시연으로 넘어가겠습니다.`,
        audioUrl: {
          us: "audios/part4/speech/us/us12.mp3",
          uk: "audios/part4/speech/uk/uk12.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main purpose of the speech?",
        questionKr: "이 연설의 주요 목적은 무엇입니까?",
        options: {
          A: "To discuss a recent <mark>product</mark> <mark>recall</mark>",
          B: "To explain <mark>software</mark> <mark>updates</mark>",
          C: "To introduce a <mark>new</mark> <mark>product</mark>",
          D: "To promote a company's <mark>anniversary</mark> event",
        },
        optionsKr: {
          A: "최근의 제품 리콜에 대해 논의하기 위해",
          B: "소프트웨어 업데이트를 설명하기 위해",
          C: "새로운 제품을 소개하기 위해",
          D: "회사의 기념일 행사를 홍보하기 위해",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 최근의 제품 리콜에 대해 논의하기 위해
  B: 소프트웨어 업데이트를 설명하기 위해
  C: 새로운 제품을 소개하기 위해
  D: 회사의 기념일 행사를 홍보하기 위해
  
  정답 C: 스크립트의 "Thank you all for joining us at the official launch of our latest innovation, the VisionX Smartwatch"에서 이 연설의 목적이 새로운 제품을 소개하는 것임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "What benefit is offered to customers who purchase during the <mark>first week</mark>?",
        questionKr: "첫 주에 구매하는 고객에게 어떤 혜택이 제공됩니까?",
        options: {
          A: "A <mark>free</mark> <mark>accessory</mark>",
          B: "A <mark>reduced price</mark>",
          C: "An <mark>extended warranty</mark>",
          D: "A <mark>free training</mark> session",
        },
        optionsKr: {
          A: "무료 액세서리",
          B: "할인된 가격",
          C: "연장된 보증 기간",
          D: "무료 트레이닝 세션",
        },
        correctAnswer: "B",
        explanation: `[선택지 해석]
      A: 무료 액세서리
      B: 할인된 가격
      C: 연장된 보증 기간
      D: 무료 트레이닝 세션
      
      정답 B: 스크립트의 "As a special promotion, customers who order within the first week will receive a 15% discount"에서 첫 주에 구매하는 고객에게 15% 할인된 가격이 제공된다는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What will happen next?",
        questionKr: "다음에 무엇이 진행됩니까?",
        options: {
          A: "A <mark>product demonstration</mark> will take place",
          B: "A <mark>question-and-answer</mark> session will begin",
          C: "Attendees will receive <mark>free</mark> <mark>samples</mark>",
          D: "A <mark>company</mark> <mark>executive</mark> will give another <mark>speech</mark>",
        },
        optionsKr: {
          A: "제품 시연이 진행될 것이다",
          B: "질의응답 세션이 시작될 것이다",
          C: "참석자들이 무료 샘플을 받을 것이다",
          D: "회사 임원이 또 다른 연설을 할 것이다",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 제품 시연이 진행될 것이다
  B: 질의응답 세션이 시작될 것이다
  C: 참석자들이 무료 샘플을 받을 것이다
  D: 회사 임원이 또 다른 연설을 할 것이다
  
  정답 A: 스크립트의 마지막 문장 "Now, let's move on to the product demonstration!"에서 다음에 제품 시연이 진행될 것임을 알 수 있습니다.`,
      },
    ],
  },

  talk13: {
    title: "Keynote Speaker Introduction",
    titleKr: "기조 연설자 소개",
    type: "speech",
    versions: {
      basic: {
        script: `Good afternoon, everyone. It is my great pleasure to <mark>introduce today's keynote speaker</mark>, Dr. Emily Carter. She is a renowned expert in <mark>environmental science</mark> and has spent over 25 years researching climate change and sustainable energy solutions.
  Dr. Carter has published multiple award-winning studies and has advised international organizations on environmental policies. Today, she will be sharing insights on how businesses can implement eco-friendly practices to reduce their carbon footprint.
  Please join me in <mark>welcoming Dr. Emily Carter to the stage</mark>!`,
        translation: `안녕하세요 여러분. 오늘의 기조 연설자인 에밀리 카터 박사님을 소개하게 되어 매우 기쁩니다. 그녀는 환경 과학 분야의 저명한 전문가이며, 25년 이상 기후 변화와 지속 가능한 에너지 솔루션을 연구해 오셨습니다.
  카터 박사님은 다수의 수상 경력이 있는 연구를 발표하셨으며, 환경 정책에 대해 국제 기구들에 자문을 제공해 오셨습니다. 오늘 그녀는 기업들이 탄소 발자국을 줄이기 위해 어떻게 친환경 실천을 구현할 수 있는지에 대한 통찰을 공유해 주실 예정입니다.
  에밀리 카터 박사님을 무대로 모시겠습니다!`,
        audioUrl: {
          us: "audios/part4/speech/us/us13.mp3",
          uk: "audios/part4/speech/uk/uk13.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main purpose of the speech?",
        questionKr: "이 연설의 주요 목적은 무엇입니까?",
        options: {
          A: "To summarize a <mark>research</mark> <mark>paper</mark>",
          B: "To invite audience members to a <mark>workshop</mark>",
          C: "To introduce a <mark>guest</mark> <mark>speaker</mark>",
          D: "To explain the <mark>event</mark> <mark>schedule</mark>",
        },
        optionsKr: {
          A: "연구 논문을 요약하기 위해",
          B: "청중들을 워크숍에 초대하기 위해",
          C: "초청 연사를 소개하기 위해",
          D: "행사 일정을 설명하기 위해",
        },
        correctAnswer: "C",
        explanation: `[선택지 해석]
  A: 연구 논문을 요약하기 위해
  B: 청중들을 워크숍에 초대하기 위해
  C: 초청 연사를 소개하기 위해
  D: 행사 일정을 설명하기 위해
  
  정답 C: 스크립트의 첫 문장 "It is my great pleasure to introduce today's keynote speaker"에서 이 연설의 주요 목적이 초청 연사를 소개하는 것임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question: "What is mentioned about <mark>Dr. Carter</mark>?",
        questionKr: "카터 박사에 대해 언급된 내용은 무엇입니까?",
        options: {
          A: "She is an expert in <mark>environmental</mark> <mark>science</mark>",
          B: "She is a professor of <mark>economics</mark>",
          C: "She recently started a <mark>new</mark> <mark>research</mark> <mark>project</mark>",
          D: "She has written a <mark>best-selling</mark> <mark>book</mark>",
        },
        optionsKr: {
          A: "그녀는 환경 과학 분야의 전문가이다",
          B: "그녀는 경제학 교수이다",
          C: "그녀는 최근 새로운 연구 프로젝트를 시작했다",
          D: "그녀는 베스트셀러 책을 저술했다",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 그녀는 환경 과학 분야의 전문가이다
  B: 그녀는 경제학 교수이다
  C: 그녀는 최근 새로운 연구 프로젝트를 시작했다
  D: 그녀는 베스트셀러 책을 저술했다
  
  정답 A: 스크립트의 "She is a renowned expert in environmental science"에서 카터 박사가 환경 과학 분야의 전문가라는 것을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What will happen next?",
        questionKr: "다음에 무엇이 진행됩니까?",
        options: {
          A: "The <mark>guest</mark> <mark>speaker</mark> will begin her talk",
          B: "A <mark>panel</mark> <mark>discussion</mark> will <mark>start</mark>",
          C: "A <mark>short video</mark> will be played",
          D: "The audience will take a <mark>break</mark>",
        },
        optionsKr: {
          A: "초청 연사가 연설을 시작할 것이다",
          B: "패널 토론이 시작될 것이다",
          C: "짧은 영상이 상영될 것이다",
          D: "청중들이 휴식을 취할 것이다",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 초청 연사가 연설을 시작할 것이다
  B: 패널 토론이 시작될 것이다
  C: 짧은 영상이 상영될 것이다
  D: 청중들이 휴식을 취할 것이다
  
  정답 A: 스크립트의 마지막 문장 "Please join me in welcoming Dr. Emily Carter to the stage!"에서 다음에 초청 연사가 무대에 올라 연설을 시작할 것임을 알 수 있습니다.`,
      },
    ],
  },

  talk14: {
    title: "Customer Complaint Management Workshop",
    titleKr: "고객 불만 관리 워크숍",
    type: "speech",
    versions: {
      basic: {
        script: `Good morning, everyone. Welcome to our <mark>Customer Complaint</mark> Management Workshop. This session is designed to help you develop the skills needed to handle customer complaints effectively and turn negative experiences into positive ones.
  Today, we will start with an overview of <mark>common customer complaints and their causes</mark>. You will learn strategies for staying calm, listening actively, and responding professionally in difficult situations.
  After lunch, we will move on to <mark>role-playing exercises</mark>, where you will practice real-life customer service scenarios. By the end of the workshop, you will feel more confident in handling customer concerns.
  Let's begin with our first session.`,
        translation: `안녕하세요 여러분. 고객 불만 관리 워크숍에 오신 것을 환영합니다. 이 세션은 여러분이 고객 불만을 효과적으로 처리하고 부정적인 경험을 긍정적인 것으로 바꾸는 데 필요한 기술을 개발하도록 돕기 위해 설계되었습니다.
  오늘은 일반적인 고객 불만과 그 원인에 대한 개요로 시작하겠습니다. 여러분은 어려운 상황에서 침착함을 유지하고, 적극적으로 경청하며, 전문적으로 대응하는 전략을 배우게 될 것입니다.
  점심 식사 후에는 실제 고객 서비스 시나리오를 연습하는 역할극 실습으로 넘어갈 예정입니다. 워크숍이 끝날 때쯤이면, 여러분은 고객 불만을 처리하는 데 더 자신감을 갖게 될 것입니다.
  첫 번째 세션을 시작하겠습니다.`,
        audioUrl: {
          us: "audios/part4/speech/us/us14.mp3",
          uk: "audios/part4/speech/uk/uk14.mp3",
        },
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main purpose of the workshop?",
        questionKr: "이 워크숍의 주요 목적은 무엇입니까?",
        options: {
          A: "To train employees in handling <mark>customer</mark> <mark>complaints</mark>",
          B: "To discuss <mark>new</mark> <mark>sales</mark> <mark>techniques</mark>",
          C: "To introduce a <mark>new</mark> customer service <mark>software</mark>",
          D: "To announce changes in company <mark>policies</mark>",
        },
        optionsKr: {
          A: "직원들에게 고객 불만 처리 방법을 교육하기 위해",
          B: "새로운 판매 기법을 논의하기 위해",
          C: "새로운 고객 서비스 소프트웨어를 소개하기 위해",
          D: "회사 정책의 변경사항을 발표하기 위해",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 직원들에게 고객 불만 처리 방법을 교육하기 위해
  B: 새로운 판매 기법을 논의하기 위해
  C: 새로운 고객 서비스 소프트웨어를 소개하기 위해
  D: 회사 정책의 변경사항을 발표하기 위해
  
  정답 A: 스크립트의 "Welcome to our Customer Complaint Management Workshop. This session is designed to help you develop the skills needed to handle customer complaints effectively"에서 이 워크숍의 주요 목적이 직원들에게 고객 불만 처리 방법을 교육하는 것임을 알 수 있습니다.`,
      },
      {
        id: 2,
        question:
          "What will participants <mark>learn</mark> <mark>first</mark>?",
        questionKr: "참가자들이 가장 먼저 배울 내용은 무엇입니까?",
        options: {
          A: "The causes of common customer <mark>complaints</mark>",
          B: "How to increase customer <mark>loyalty</mark>",
          C: "Techniques for promoting <mark>new</mark> <mark>products</mark>",
          D: "The company's updated <mark>refund</mark> <mark>policy</mark>",
        },
        optionsKr: {
          A: "일반적인 고객 불만의 원인",
          B: "고객 충성도를 높이는 방법",
          C: "새로운 제품을 홍보하는 기법",
          D: "회사의 업데이트된 환불 정책",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 일반적인 고객 불만의 원인
  B: 고객 충성도를 높이는 방법
  C: 새로운 제품을 홍보하는 기법
  D: 회사의 업데이트된 환불 정책
  
  정답 A: 스크립트의 "Today, we will start with an overview of common customer complaints and their causes"에서 참가자들이 가장 먼저 일반적인 고객 불만의 원인에 대해 배울 것임을 알 수 있습니다.`,
      },
      {
        id: 3,
        question: "What activity is planned for the <mark>afternoon</mark>?",
        questionKr: "오후에 계획된 활동은 무엇입니까?",
        options: {
          A: "<mark>Role-playing</mark> exercises",
          B: "A <mark>team-building</mark> activity",
          C: "A <mark>lecture</mark> from a guest speaker",
          D: "A discussion on <mark>workplace</mark> <mark>ethics</mark>",
        },
        optionsKr: {
          A: "역할극 실습",
          B: "팀 빌딩 활동",
          C: "초청 연사의 강연",
          D: "직장 윤리에 대한 토론",
        },
        correctAnswer: "A",
        explanation: `[선택지 해석]
  A: 역할극 실습
  B: 팀 빌딩 활동
  C: 초청 연사의 강연
  D: 직장 윤리에 대한 토론
  
  정답 A: 스크립트의 "After lunch, we will move on to role-playing exercises"에서 오후(점심 식사 후)에는 역할극 실습이 계획되어 있음을 알 수 있습니다.`,
      },
    ],
  },
};
